import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export default makeStyles(() =>
  createStyles({
    alert: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '& .MuiAlert-message': {
        width: '100%',
      },
    },
  }),
);
